import { TIdToPageMap } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioArch81 } from './pages'

export const ID_TO_PAGE_MAP_STYLIO_ARCH_81: TIdToPageMap = {
  [PageIdStylioArch81.SUBSCRIPTIONS_ARCH_81]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_81/pages/ArchSubscriptionPage').then(
        (m) => ({
          default: m.ArchSubscriptionPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_81/pages/ArchSubscriptionPage'),
  },
  [PageIdStylioArch81.SUB_UPSELL_ARCH_81]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_81/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_81/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioArch81.FACE_STYLING_PDF_UPSELL_ARCH_81]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_81/pages/third-pdf-upsell/ThirdPdfUpsell'
      ).then((m) => ({
        default: m.ThirdPdfUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_81/pages/third-pdf-upsell/ThirdPdfUpsell'
      ),
  },
  [PageIdStylioArch81.PROPORTIONS_PDF_UPSELL_ARCH_81]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_81/pages/ProportionsPdfUpsell').then(
        (m) => ({
          default: m.ProportionsPdfUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_81/pages/ProportionsPdfUpsell'),
  },
  [PageIdStylioArch81.DOWNLOAD_ARCH_81]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_81/pages/download-arch/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_81/pages/download-arch/DownloadDefault'
      ),
  },
}
